import React, { Fragment, useState, useEffect } from "react";
import {
  FormGroup,
  Label,
  Input,
  Spinner,
  Form,
  FormFeedback,
  Button,
  Row,
  Col,
  Container,
  Card,
} from "reactstrap";
import { useParams, useNavigate } from "react-router-dom";
import {
  DOG_CATEGORY_ANSWER,
  DOG_REQUIRED_DOCUMENT_ANSWERS,
  GET_DOG_LICENCE_ID,
  UPLOAD_FILE,
  USER_CHOOSE_PLAN,
} from "../../../constants/ApiPaths";
import {
  authHeader,
  customerName,
  customerState,
} from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { END_USER_DETAILS_SUCCESS } from "../../../redux/actions/ActionTypes";
import { useFormik } from "formik";
import YupSchemaCreator from "../../Agency/Template/YupSchemaCreator";
import * as Yup from "yup";
import BackButtonSvg from "../../common/BackButtonSvg";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";

export const InputField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, placeholder = "", label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;
  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          onChange={handlechange}
          value={values[uniqueId]}
          type="text"
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          placeholder={placeholder}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const TextAreaField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, placeholder = "", label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          value={values[uniqueId]}
          onChange={handlechange}
          type="textarea"
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          placeholder={placeholder}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};
export const FileUploadField = (props) => {
  const {
    values = {},
    setpageloading,
    formik,
  } = props;
  const {
    licenseRequiredDocId,
    documentName = "",
    documentDescription = "",
  } = props.data || {};

  const handleFileUpload = async (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const formDat = new FormData();
      formDat.append("file", selectedFile);
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        data: formDat,
        headers: authHeader(),
      };
      setpageloading(true);
      try {
        const response = await API(config);
        const { status, filePath } = response.data;
        if (status === "Success") {
          formik.setFieldValue(licenseRequiredDocId, filePath);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setpageloading(false);
      }
    }
  };

  return (
    <Col md={4} key={licenseRequiredDocId}>
      <FormGroup>
        <Label for={licenseRequiredDocId}>{documentName}</Label>
        <Input
          value={values[licenseRequiredDocId]}
          onChange={handleFileUpload}
          type="file"
          required
          name={licenseRequiredDocId}
          id={licenseRequiredDocId}
          placeholder={documentDescription}
        />
      </FormGroup>
    </Col>
  );
};

export const DateField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          type="date"
          value={values[uniqueId]}
          onChange={handlechange}
          name={uniqueId}
          id={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const TimeField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const { uniqueId, label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label for={uniqueId}>{label}</Label>
        <Input
          type="time"
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          value={values[uniqueId]}
          onChange={handlechange}
          name={uniqueId}
          id={uniqueId}
        />
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const SelectField = (props) => {
  const { handlechange, values = {},  formik } = props;
  const {
    type,
    uniqueId,
    placeholder = "",
    options = [],
    label = "",
  } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;
  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label>{label}</Label>
        <Input
          type={type}
          onChange={handlechange}
          value={values[uniqueId]}
          id={uniqueId}
          name={uniqueId}
          onBlur={handleBlur}
          invalid={touched[uniqueId] && errors[uniqueId]}
          placeholder={placeholder}
        >
          <option>Please Select</option>
          {options.map((o) => (
            <option value={o.value} key={o.value}>
              {o.value}
            </option>
          ))}
        </Input>
        <FormFeedback>
          {touched[uniqueId] && errors[uniqueId] && (
            <div>{errors[uniqueId]}</div>
          )}
        </FormFeedback>
      </FormGroup>
    </Col>
  );
};

export const CheckboxField = (props) => {
  const { handlechange,  formik } = props;
  const { uniqueId, options = [], label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label>{label}</Label>
        {options.map((o) => (
          <Col key={o.optionUniqueId} sm={10}>
            <FormGroup check>
              <Label check>
                <Input
                  onChange={handlechange}
                  value={o.value}
                  onBlur={handleBlur}
                  type="checkbox"
                  name={uniqueId}
                  id={uniqueId}
                  invalid={touched[uniqueId] && errors[uniqueId]}
                />{" "}
                {o.value} &nbsp;
              </Label>
            </FormGroup>
          </Col>
        ))}
        {touched[uniqueId] && errors[uniqueId] && (
          <div>
            <small style={{ color: "#dc3545" }}>Required</small>
          </div>
        )}
      </FormGroup>
    </Col>
  );
};

export const RadioField = (props) => {
  const { handlechange,  formik } = props;
  const { uniqueId, options = [], label = "" } = props.data || {};
  const { errors = {}, touched = {}, handleBlur } = formik;

  return (
    <Col md={4} key={uniqueId}>
      <FormGroup>
        <Label>{label}</Label>
        {options.map((o) => (
          <Col key={o.optionUniqueId} sm={10}>
            <FormGroup check>
              <Label check>
                <Input
                  onBlur={handleBlur}
                  onChange={handlechange}
                  type="radio"
                  key={o.optionUniqueId}
                  value={o.value}
                  name={uniqueId}
                />{" "}
                {o.value} &nbsp;
              </Label>
            </FormGroup>
          </Col>
        ))}
        {touched[uniqueId] && errors[uniqueId] && (
          <div>
            <small style={{ color: "#dc3545" }}>Required</small>
          </div>
        )}
      </FormGroup>
    </Col>
  );
};

export const DynamicField = (props) => {
  const fieldTypes = {
    text: InputField,
    textarea: TextAreaField,
    date: DateField,
    select: SelectField,
    radio: RadioField,
    time: TimeField,
    checkbox: CheckboxField,
  };
  const { data, handlechange, previewMode, values, formik } = props;
  const Field = fieldTypes[props?.data?.type] || InputField;
  return (
    <Field
      data={data}
      handlechange={handlechange}
      formik={formik}
      values={values}
      previewMode={previewMode}
    />
  );
};

export const BackButton = (props) => {
  const { handlePress = () => {} } = props;
  return (
    <div className="top-btn">
      <Button onClick={handlePress} color="primary">
        {" "}
        <svg
          className="mr-3"
          xmlns="http://www.w3.org/2000/svg"
          width="10.977"
          height="7.321"
          viewBox="0 0 10.977 7.321"
        >
          <path
            id="Icon_ionic-ios-arrow-round-back"
            data-name="Icon ionic-ios-arrow-round-back"
            d="M11.859,11.392a.5.5,0,0,1,0,.7L9.548,14.415h8.819a.5.5,0,0,1,0,.991H9.548l2.318,2.322a.5.5,0,0,1,0,.7.494.494,0,0,1-.7,0L8.023,15.262h0a.557.557,0,0,1-.1-.156.473.473,0,0,1-.038-.191.5.5,0,0,1,.141-.347L11.165,11.4A.486.486,0,0,1,11.859,11.392Z"
            transform="translate(-7.882 -11.252)"
            fill="#fff"
          />
        </svg>
        Back
      </Button>
    </div>
  );
};

const GuestChooseplan = () => {
  const [answers, setAnswers] = useState({});
  const [validationSchema, setValidationSchema] = useState({});
  const [loading, setLoading] = useState(false);
  const previewMode=false
  const history = useNavigate();
  const [pageloading, setpageloading] = useState(false);
  const dispatch = useDispatch();
  const { userId, licensePlanId, dogId } = useParams();
  const dog = useSelector((state) => state.Dogdetails);
  const singledog = dog.filter((i) => i.dogId === dogId)[0] || {};

  const {
    planName,
    licenseRequiredDocDetails = [],
    categoryDetails = [],
  } = useSelector((state) => state.CustomerFormReducer);
  const handleFormSubmit = async (values) => {
    setLoading(true);
    setpageloading(true);
    try {
      const getLicenseConfig = {
        method: "POST",
        url: GET_DOG_LICENCE_ID,
        headers: authHeader(),
        data: {
          dogId: dogId,
          userId: userId,
          licensePlanId: licensePlanId,
          type: "new license", // 'renewal license'
        },
      };

      const response1 = await API(getLicenseConfig);

      const dogLicenseID = response1.data?.dogLicenseId;

      console.warn(getLicenseConfig, response1);

      const createLicenseData = {
        dogLicenseId: dogLicenseID,
        categoryDetails: categoryDetails.map((cat) => {
          let catAnswer = { ...cat };
          catAnswer["categoryPlaceHolder"] = cat.categoryPlaceHolder.map(
            (catPlaceHolder) => {
              return {
                ...catPlaceHolder,
                selectedAnswer: values[catPlaceHolder.uniqueId],
              };
            }
          );
          return {
            categoryAnswerId: 0,
            categoryId: cat.categoryId,
            categoryAnswer: JSON.stringify(catAnswer),
          };
        }),
      };

      const createLicenseConfig = {
        method: "POST",
        url: DOG_CATEGORY_ANSWER,
        data: createLicenseData,
        headers: authHeader(),
      };

      const documentDetails = licenseRequiredDocDetails.map((e) => {
        return {
          licenseRequiredDocDetailsId: 0,
          licenseRequiredDocId: e.licenseRequiredDocId,
          filePath: values[e.licenseRequiredDocId],
          documentValidFrom: "",
          documentValidTo: "",
          categoryId: e.categoryid,
        };
      });

      const requiredDocConfig = {
        method: "POST",
        url: DOG_REQUIRED_DOCUMENT_ANSWERS,
        headers: authHeader(),
        data: {
          dogId: dogId,
          dogLicenseId: dogLicenseID,
          documentDetails: documentDetails,
        },
      };

      await API(createLicenseConfig);
      await API(requiredDocConfig);
      window.sessionStorage.setItem("PAYMENT_DOGLICENSE_ID", dogLicenseID);
      window.sessionStorage.setItem(
        "PAYMENT_DOGLICENSE_LICENSEPLANID",
        licensePlanId
      );
      window.sessionStorage.setItem("PAYMENT_DOGLICENSE_USERID", userId);

      setLoading(false);
      history("/agency/payment");
    } catch (error) {
      console.error(error);
    } finally {
      setpageloading(false);
      setLoading(false);
    }
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: answers,
    validationSchema: validationSchema,
    onSubmit: handleFormSubmit,
  });

  const { handleSubmit, handleChange, values = {} } = formik;
 

  const fetchStateForm = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: USER_CHOOSE_PLAN,
      headers: authHeader(),
      params: {
        licensePlanId: licensePlanId,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        const { licensePlanData } = response.data;
        dispatch({
          type: END_USER_DETAILS_SUCCESS,
          payload: licensePlanData,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStateForm();
  }, []);

  useEffect(() => {
    let questions = [];
    categoryDetails.forEach((e) => {
      questions.push(...e.categoryPlaceHolder);
    });

    questions = questions.filter((e) => e.isMandatory);
    questions = questions.map((question) => {
      if (question.type === "checkbox") {

        question.validationType = "array";
        question.validations = [
          {
            type: "min",
            params: [1], // at least one checkbox should be selected
          },
        ];
      }
      return question;
    });

    const yupSchema = questions.reduce(YupSchemaCreator, {});

    const schema = Yup.object().shape(yupSchema);

    setValidationSchema(schema);
  }, [answers]);

  useEffect(() => {
    const answers = {};
    const specialfunction = {
      PET_VALUE: singledog.dogName,
      USER_NAME: customerName(),
      PET_BREED: singledog.breed,
      CUSTOMER_STATE: customerState(),
      PET_COLOR: singledog.color,
    };
    categoryDetails.forEach(({ categoryPlaceHolder = [] }) => {
      categoryPlaceHolder.forEach(({ uniqueId, type, specialvalue }) => {
        if (!uniqueId) return;
        if (specialvalue) {
          answers[uniqueId] = specialfunction[specialvalue];
        } else {
          answers[uniqueId] = type === "checkbox" ? [] : "";
        }
      });
    });
    licenseRequiredDocDetails.forEach((e) => {
      answers[e.licenseRequiredDocId] = "";
    });
    setAnswers(answers);
  }, [categoryDetails, licenseRequiredDocDetails]);


  const Back = () => {
    history(-1);
  };
  return (
    <div>
      <div className="agency-wrapper">
        {pageloading && <CustomPageLoading />}

        <Container style={{ paddingBottom: "30px" }}>
          <div className="page-title">
            <h4>{planName}</h4>
            <div className="top-btn">
              <Button onClick={Back} color="primary">
                <BackButtonSvg />
                Back
              </Button>
            </div>
          </div>

          <Card body className="mt-4">
            <Form form="true" id="endUserLicenseForm" onSubmit={handleSubmit}>
              {categoryDetails.map((e) => {
                const categoryDocs = licenseRequiredDocDetails.filter(
                  (doc) => doc.categoryid === e.categoryId
                );
                return (
                  <Fragment key={e.categoryId}>
                    <div className="category-title">
                      <h4>{e.categoryName}</h4>
                    </div>
                    <div>
                      <Row>
                        {e.categoryPlaceHolder.map((field) => {
                          return (
                            <Fragment key={field.uniqueId}>
                              <DynamicField
                                handlechange={handleChange}
                                formik={formik}
                                values={values}
                                previewMode={previewMode}
                                data={field}
                              />
                            </Fragment>
                          );
                        })}
                      </Row>
                      {!!categoryDocs.length && (
                        <>
                          <div className="category-documents">
                            <h6>Additional Documents</h6>
                          </div>
                          <Row>
                            {categoryDocs.map((doc) => (
                              <Fragment>
                                <FileUploadField
                                  data={doc}
                                  setpageloading={setpageloading}
                                  formik={formik}
                                />
                              </Fragment>
                            ))}
                          </Row>
                        </>
                      )}
                    </div>
                  </Fragment>
                );
              })}
            </Form>
            <div className="centerFlexRow">
              <Button form="endUserLicenseForm" type="submit" color="primary">
                {" "}
                {loading ? <Spinner /> : ""} Proceed to Payment
              </Button>
            </div>
          </Card>
        </Container>
      </div>
    </div>
  );
};

export default GuestChooseplan;
